import { DataProviderProxy } from 'ra-core'
import { AdaAction, saveSystemDesignAsTemplateAction } from '../actions'

export async function handleSaveSystemDesignAsTemplate(
  action: AdaAction,
  orgId: number | undefined,
  projectId: number | undefined,
  dataProvider: DataProviderProxy
) {
  try {
    await saveSystemDesignAsTemplateAction(action.args, orgId, projectId, dataProvider)
    if (window.debugAdaActions) console.log('Template saved successfully')
  } catch (error) {
    console.error('Error saving template:', error)
  }
}
